import React from "react";

const WarrantyBoatTable = () => {
    const data = [
        ["UNIVERSAL BOAT COVERS", "$75.00", "$70.00"],
        ["CENTER CONSOLE BOATS", "$80.00", "$75.00"],
        ["BASS BOATS", "$80.00", "$75.00"],
        ["INFLATABLE BOATS / RIBS", "$80.00", "$75.00"],
        ["DECK BOATS", "$90.00", "$85.00"],
        ["BIMINI TOPS", "$105.00", "$100.00"],
        ["PONTOON BOATS", "$110.00", "$100.00"],
        ["WAKEBOARD / SKI BOATS", "$110.00", "$105.00"],
        ["T-TOP BOATS", "$150.00", "$140.00"]]

    const images = [
        null,
        "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/4a93f6a9b7247710787b47c62083e1573ef80660.png?v=1766069783",
        "https://cdn.shopify.com/s/files/1/0168/9760/5686/files/96ba6234e09a9935ea5abf9e551ba6f610f1e763.png?v=1766069783",

    ]
    return (
        <div className="table-block table-block--warranty-boat">
            <div className="table-block">
                <div className="table-block__header">
                    <div className="table-block__header-cell table-block__header-cell--category">Category</div>
                    <div className="table-block__header-cell table-block__header-cell--supreme">Supreme</div>
                    <div className="table-block__header-cell table-block__header-cell--elite">Elite</div>
                </div>

                {data.map((row, index) => (
                    <div className="table-block__row" key={index}>
                        <div className="table-block__cell">{row[0]}</div>
                        <div className="table-block__cell">{row[1]}</div>
                        <div className="table-block__cell">{row[2]}</div>
                    </div>
                ))}

                <div className="table-block__row">
                    {images.map((row, index) => (
                        <div className="table-block__cell table-block__cell--padding-none" key={index}>
                            {row ? <div className="table-block__warranty-badge-container"> <img className="table-block__warranty-badge" src={row} alt={row} /> </div   > : null}
                        </div>
                    ))}
                </div>

            </div>
        </div>
    );
};

export default WarrantyBoatTable;